(function () {
  'use strict';
  function mapCadence(source, destination, selectedId) {
    if (!selectedId) return null;
    const selected = source.filter(p => p.recurring === true && p.id === String(selectedId));
    if (selected.length !== 1 || !selected[0].cadence) return null;
    const matches = destination.filter(p => p.recurring === true && p.cadence === selected[0].cadence);
    return matches.length === 1 ? matches[0].id : null;
  }
  function validQuantity(input, value) {
    const n = Number(value), min = Number(input.min || 1), max = input.max ? Number(input.max) : Infinity, step = Number(input.step || 1);
    return /^\d+$/.test(String(value)) && Number.isSafeInteger(n) && n >= min && n <= max && step > 0 && (n - min) % step === 0;
  }
  function init(family) {
    if (family.dataset.ready) return;
    family.dataset.ready = 'true';
    const links = [...family.querySelectorAll('.ds-release-swatch')];
    const source = links.find(a => a.getAttribute('aria-current') === 'page');
    if (!source) return;
    const plans = a => { try { return JSON.parse(a.querySelector('[data-ds-plans]').textContent); } catch { return []; } };
    const bases = new Map(links.map(a => [a, a.href]));
    const form = () => document.getElementById(family.dataset.formId);
    const quantity = () => form()?.querySelector('input[name="quantity"]:not([type="hidden"]):not(:disabled)');
    const currentURL = new URL(location.href);
    const incoming = currentURL.searchParams.get('ds_quantity');
    const purchaseIntent = currentURL.searchParams.get('ds_purchase');
    if (incoming !== null) {
      const input = quantity();
      if (input && validQuantity(input, incoming)) { input.value = incoming; input.dispatchEvent(new Event('change', { bubbles: true })); }
      currentURL.searchParams.delete('ds_quantity');
      history.replaceState(history.state, '', currentURL);
    }
    function update(event) {
      const native = form();
      const variant = native?.querySelector('[name="id"]');
      const selected = [...(native?.querySelectorAll('[name="selling_plan"]:not(:disabled)') || [])].filter(i => i.value && (!['radio', 'checkbox'].includes(i.type) || i.checked));
      const ids = [...new Set(selected.map(i => i.value))];
      const plan = variant?.value === source.dataset.variantId && ids.length === 1 ? ids[0] : null;
      const input = quantity();
      if (['pointerdown', 'click', 'contextmenu'].includes(event?.type) && event.target.closest('.ds-release-swatch')) {
        const backURL = new URL(location.href);
        if (plan && mapCadence(plans(source), plans(source), plan) === plan) {
          backURL.searchParams.set('selling_plan', plan);
          if (!purchaseIntent) backURL.searchParams.delete('ds_purchase');
        } else {
          backURL.searchParams.delete('selling_plan');
          backURL.searchParams.set('ds_purchase', 'review');
        }
        history.replaceState(history.state, '', backURL);
      }
      links.forEach(a => {
        const url = new URL(bases.get(a), location.href);
        const preview = new URL(location.href).searchParams.get('preview_theme_id');
        if (preview) url.searchParams.set('preview_theme_id', preview);
        const mapped = mapCadence(plans(source), plans(a), plan);
        if (mapped) { url.searchParams.set('selling_plan', mapped); if (purchaseIntent) url.searchParams.set('ds_purchase', 'review'); else url.searchParams.delete('ds_purchase'); }
        else url.searchParams.set('ds_purchase', 'review');
        if (input && validQuantity(input, input.value)) url.searchParams.set('ds_quantity', input.value);
        a.href = url.href;
      });
    }
    ['pointerdown', 'click', 'contextmenu', 'focusin'].forEach(name => family.addEventListener(name, update, true));
    document.addEventListener('change', update);
    if (purchaseIntent) requirePurchaseReview({ family, source, plans: () => plans(source), form });
    update();
  }
  const failedFamilies = new WeakSet();
  function failClosed(family) {
    if (failedFamilies.has(family)) return;
    failedFamilies.add(family);
    const notice = family.querySelector('[data-ds-purchase-check]');
    const confirm = notice?.querySelector('[data-ds-confirm-purchase]');
    if (notice) notice.hidden = false;
    if (confirm) { confirm.disabled = true; confirm.textContent = 'Purchase confirmation unavailable. Reload this page before adding.'; }
    const lock = () => document.querySelectorAll('form[action*="/cart/add"] button[type="submit"],form[action*="/cart/add"] input[type="submit"],form[action*="/cart/add"] [name="add"]').forEach(button => { if (!button.disabled) button.disabled = true; });
    const block = event => {
      const native = event.type === 'submit' ? event.target : event.target.closest('button[type="submit"],input[type="submit"],[name="add"]')?.form;
      if (native?.matches('form[action*="/cart/add"]')) { event.preventDefault(); event.stopImmediatePropagation(); }
    };
    window.addEventListener('click', block, true);
    window.addEventListener('submit', block, true);
    lock();
    if (document.documentElement) new MutationObserver(lock).observe(document.documentElement, { childList: true, subtree: true, attributes: true, attributeFilter: ['disabled'] });
  }
  function requirePurchaseReview(options) {
    try { configurePurchaseReview(options); } catch { failClosed(options.family); }
  }
  function configurePurchaseReview({ family, source, plans, form }) {
    const notice = family.querySelector('[data-ds-purchase-check]');
    const confirm = notice?.querySelector('[data-ds-confirm-purchase]');
    if (!notice || !confirm) throw new Error('Purchase confirmation markup missing');
    let accepted = null, displayed = null;
    const locks = new Map();
    const primary = form();
    const guardedIds = new Set([family.dataset.formId, primary?.getAttribute('id'), primary?.getAttribute('id')?.replace(/^product-form-/, 'product-form-Sticky-')].filter(Boolean));
    function choice(native = form(), allowAbsent = false) {
      if (native?.querySelector('[name="id"]')?.value !== source.dataset.variantId) return null;
      const fields = [...native.querySelectorAll('[name="selling_plan"]')];
      if (!fields.length && !allowAbsent) return null;
      const ids = [...new Set(fields.filter(i => !i.disabled && i.value && (!['radio', 'checkbox'].includes(i.type) || i.checked)).map(i => i.value))];
      if (ids.length > 1) return null;
      if (!ids.length) return { signature: JSON.stringify([source.dataset.variantId, 'one-time', family.dataset.oneTimePrice]), label: 'Confirm one-time purchase — ' + family.dataset.oneTimePrice };
      const currentPlans = typeof plans === 'function' ? plans() : plans;
      const matches = currentPlans.filter(p => p.id === ids[0] && p.recurring === true);
      if (matches.length !== 1 || !matches[0].price || !matches[0].name) return null;
      return { signature: JSON.stringify([source.dataset.variantId, 'subscription', ids[0], matches[0].price, matches[0].name, matches[0].cadence, matches[0].recurring]), label: 'Confirm subscription — ' + matches[0].name + ' — ' + matches[0].price };
    }
    function isPurchaseForm(native) {
      return native?.matches('form[action*="/cart/add"]') && (native === primary || native === form() || guardedIds.has(native.getAttribute('id')));
    }
    function refresh() {
      const current = choice();
      if (!current || current.signature !== accepted) {
        accepted = null;
        displayed = current?.signature || null;
        notice.hidden = false;
        confirm.disabled = !current;
        const label = current?.label || 'Waiting for delivery options…';
        if (confirm.textContent !== label) confirm.textContent = label;
        document.querySelectorAll('form[action*="/cart/add"]').forEach(native => {
          if (!isPurchaseForm(native)) return;
          native.querySelectorAll('button[type="submit"],input[type="submit"],[name="add"]').forEach(button => {
            if (!locks.has(button)) locks.set(button, { wasDisabled: button.disabled, native });
            if (!button.disabled) button.disabled = true;
          });
        });
        return false;
      }
      notice.hidden = true;
      locks.forEach(({ wasDisabled, native }, button) => { if (choice(native, true)?.signature !== accepted) return; if (!wasDisabled && button.isConnected && button.disabled) button.disabled = false; locks.delete(button); });
      return true;
    }
    confirm.addEventListener('click', () => {
      const current = choice();
      if (!current || current.signature !== displayed) { accepted = null; refresh(); return; }
      accepted = current.signature;
      refresh();
      form()?.querySelector('[name="add"]')?.focus({ preventScroll: true });
    });
    function intercept(event) {
      const native = event.type === 'submit' ? event.target : event.target.closest('button[type="submit"],input[type="submit"],[name="add"]')?.form;
      if (!isPurchaseForm(native)) return;
      try {
        if (!refresh() || choice(native, true)?.signature !== accepted) { event.preventDefault(); event.stopImmediatePropagation(); notice.hidden = false; confirm.focus({ preventScroll: true }); }
      } catch { event.preventDefault(); event.stopImmediatePropagation(); failClosed(family); }
    }
    window.addEventListener('click', intercept, true);
    window.addEventListener('submit', intercept, true);
    document.addEventListener('change', refresh);
    window.addEventListener('click', () => window.setTimeout(refresh, 0), true);
    window.addEventListener('keyup', () => window.setTimeout(refresh, 0), true);
    const observer = new MutationObserver(refresh);
    document.querySelectorAll('form[action*="/cart/add"]').forEach(native => {
      if (isPurchaseForm(native)) observer.observe(native, { childList: true, subtree: true, attributes: true, attributeFilter: ['value', 'disabled'] });
    });
    observer.observe(family, { attributes: true, attributeFilter: ['data-one-time-price'] });
    family.querySelectorAll?.('[data-ds-plans]').forEach(script => observer.observe(script, { childList: true, characterData: true, subtree: true }));
    refresh();
  }
  if (typeof module !== 'undefined' && module.exports) module.exports = { mapCadence, validQuantity, requirePurchaseReview };
  else {
    const safeInit = family => { try { init(family); } catch { if (new URL(location.href).searchParams.has('ds_purchase')) failClosed(family); } };
    document.querySelectorAll('[data-ds-release-family]').forEach(safeInit);
    document.addEventListener('shopify:section:load', () => document.querySelectorAll('[data-ds-release-family]').forEach(safeInit));
  }
}());
